import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
export var S3ExpressIdentityCache = /*#__PURE__*/function () {
  function S3ExpressIdentityCache() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, S3ExpressIdentityCache);
    this.data = data;
    this.lastPurgeTime = Date.now();
  }
  _createClass(S3ExpressIdentityCache, [{
    key: "get",
    value: function get(key) {
      var entry = this.data[key];
      if (!entry) {
        return;
      }
      return entry;
    }
  }, {
    key: "set",
    value: function set(key, entry) {
      this.data[key] = entry;
      return entry;
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      delete this.data[key];
    }
  }, {
    key: "purgeExpired",
    value: function () {
      var _purgeExpired = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var now, key, entry, credential;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                now = Date.now();
                if (!(this.lastPurgeTime + S3ExpressIdentityCache.EXPIRED_CREDENTIAL_PURGE_INTERVAL_MS > now)) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                _context.t0 = _regeneratorRuntime.keys(this.data);
              case 4:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 14;
                  break;
                }
                key = _context.t1.value;
                entry = this.data[key];
                if (entry.isRefreshing) {
                  _context.next = 12;
                  break;
                }
                _context.next = 10;
                return entry.identity;
              case 10:
                credential = _context.sent;
                if (credential.expiration) {
                  if (credential.expiration.getTime() < now) {
                    delete this.data[key];
                  }
                }
              case 12:
                _context.next = 4;
                break;
              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function purgeExpired() {
        return _purgeExpired.apply(this, arguments);
      }
      return purgeExpired;
    }()
  }]);
  return S3ExpressIdentityCache;
}();
S3ExpressIdentityCache.EXPIRED_CREDENTIAL_PURGE_INTERVAL_MS = 30000;